exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom_image-viewer__button[data-v-7f23f7a6]{width:150px}button[data-v-7f23f7a6]{font-size:1.3em;-webkit-appearance:button;border:none;border-radius:10px;height:50px;color:#fff;background:#6893e7}.el-image-viewer__actions[data-v-7f23f7a6]{background:unset}", ""]);

// exports
